import { useReducer, useEffect } from 'react'
import { Toolbar, IconButton, Button, Box } from '@mui/material'

import { Menu as MenuIcon, Bolt } from '@mui/icons-material'
import { Autocomplete, Grid } from '../UniversalComponents'
import NavMenuAvatar from './NavMenuAvatar'

import { useMinimizer } from '../../context/MinimizeContext'
import { useQuickStartWizard } from '../../context/QuickStartWizard'
import { useAuth } from '../../context/AuthenticationContext'
import { getManufacturers } from '../../apiRoutes'
import { useGlobalState } from '../../context/GlobalStateContext'

const NavMenuToolbar = ({ handleDrawerToggle }) => {
    const { minimizedModals, setMinimized } = useMinimizer()
    const { setQuickStartWizard } = useQuickStartWizard()
    const { auth } = useAuth()
    // const { userProfile } = auth
    // const { superAdmin, userProfileAssignedManufacturers } = userProfile
    // const { activeManufacturer } = auth

    const { globalState, setUser } = useGlobalState()
    const { oupUser } = globalState
    const { userProfile, activeManufacturer } = oupUser
    const { superAdmin, userProfileAssignedManufacturers } = userProfile
    const { manufacturerName } = activeManufacturer

    const defaultState = {
        manufacturers: [],
        manufacturerOptions: [],
    }

    const reducer = (state, newState) => ({ ...state, ...newState })
    const [state, setState] = useReducer(reducer, defaultState)
    const { manufacturers, manufacturerOptions } = state

    const getData = async () => {
        let manufacturers: any = []
        let manufacturerOptions: any = []
        if (superAdmin && superAdmin === true) {
            const getManufacturerData = await getManufacturers(true)
            if (getManufacturerData?.length !== 0) {
                manufacturers = getManufacturerData
                manufacturerOptions = getManufacturerData?.map(
                    ({ manufacturerName }) => manufacturerName
                )
            }
        } else {
            manufacturerOptions =
                userProfileAssignedManufacturers?.length !== 0 &&
                userProfileAssignedManufacturers?.map(
                    ({ manufacturerName }) => manufacturerName
                )

            manufacturers = userProfileAssignedManufacturers
        }

        setState({
            manufacturerOptions,
            manufacturers,
        })
    }

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        getData()
    }, [userProfileAssignedManufacturers])

    return (
        <Toolbar className="navigation-menu-toolbar-background">
            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{
                    mr: 2,
                    display: { sm: 'none', md: 'none', lg: 'none' },
                }}
            >
                <MenuIcon />
            </IconButton>

            <Grid item xs={8} md={8} lg={8}>
                {manufacturers?.length > 1 && (
                    <Autocomplete
                        id="activeManufacturer"
                        options={manufacturerOptions}
                        handleChange={(e: any) => {
                            const { name, value } = e.target

                            const getFullManufacturer = manufacturers.find(
                                ({ manufacturerName }) =>
                                    manufacturerName === value
                            )

                            setUser({
                                key: name,
                                value: getFullManufacturer,
                            })
                        }}
                        value={manufacturerName}
                        label="Active Manufacturer"
                        name="activeManufacturer"
                        sx={{
                            flexGrow: 1,
                            paddingRight: 50,
                            marginLeft: 30,
                        }}
                    />
                )}
            </Grid>
            <Grid item xs={3} md={3} lg={3} />

            <Grid item xs={1} md={1} lg={1}>
                <NavMenuAvatar />
            </Grid>
        </Toolbar>
    )
}

export default NavMenuToolbar
